import { gql } from "@apollo/client";
const member = ` 
     _id
      name
      email
      mobile
      role
      partnerId
      isActive
      isVerified
      createdAt
`;

/**
 * GET MEMBERS
 */

export const LIST_PARTNER_MEMBERS = gql`
  query ListPartnerMembers($pagination: PaginationInput!, $filter: PartnerFilterInput!) {
    listPartnerMembers(pagination: $pagination, filter: $filter) {
      items {
        ${member}
      }
      pageInfo {
        currentPage
        totalPages
        currentItem
        totalItems
      }
    }
  }
`;

/**
 * ADD MEMBER
 */

export const ADD_PARTNER_MEMBER = gql`
  mutation CreatePartnerMember($input: CreatePartnerMemberInput!) {
    createPartnerMember(input: $input) {
      ${member}
    }
  }
`;
